import React from 'react';
import { DecisionHeaderSubtitle } from '../../../../decision/header/DecisionHeaderSubtitle';
import { DecisionHeaderTitle } from '../../../../decision/header/DecisionHeaderTitle';
import { Decision } from '../../../../decision/decision.types';
import { addNewPositionToUrl } from '../../../../decision/decisionUtils';

type Props = {
  index: number;
  decision: Decision;
  source: string;
};

DecisionSearchHeader.defaultProps = {
  index: 0,
};

export function DecisionSearchHeader({ decision, index, source }: Props) {
  const onDecisionTitleClicked = () => {
    const position = typeof index !== 'undefined' ? index : 0;
    addNewPositionToUrl(position);
  };

  return (
    <>
      <DecisionHeaderTitle
        decision={decision}
        index={index}
        source={source}
        onDecisionTitleClicked={onDecisionTitleClicked}
      />
      <DecisionHeaderSubtitle
        arretDecAtt={decision.arretDecAtt}
        solution={decision.solution}
        validation={decision.validation}
        docId={decision.docId}
        automaticMetadata={decision.automaticMetadata}
        source={source}
      />
    </>
  );
}
